<template>
    <span :class="$style.message">{{ title }}</span>
</template>

<script>
export default {
    name: "WarningInputMessage",
    props: {
        title: { type: String, required: true },
    },
};
</script>

<style module>
.message {
    font-size: 12px;
    height: 12px;
    display: block;
    margin-top: 12px;
    margin-left: 12px;
    color: rgb(255, 0, 0);
}
</style>
